export enum PAGE_NAME_PROMO {
  PROMO_LISTING_PAGE = 'promo listing page',
}
